import { domainEnvironment } from 'libs/shared/utils/variables/domains';
import { prodEnvironment } from 'libs/shared/utils/variables/environments/prod';
import { firebaseEnvironment } from 'libs/shared/utils/variables/firebase';
import { miscEnvironment } from 'libs/shared/utils/variables/misc';

export const environment = {
  production: true,
  ...prodEnvironment,
  ...firebaseEnvironment,
  ...domainEnvironment,
  ...miscEnvironment,
};
